export const HeaderButtonIcons = {
  back: 'arrow-back' as const,
  close: 'close' as const,
};
